module.exports = __webpack_public_path__ + "media/intro_web_video.d898f04e.mp4";